import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
interface AccordionItemProps {
  title: string;
  content: string[];
  isOpen: boolean;
  onToggle: () => void;
  image?: string;
}
export function AccordionItem({
  title,
  content,
  isOpen,
  onToggle,
  image
}: AccordionItemProps) {
  return <div className="border border-[#1a3d1f]/20 rounded-lg mb-4 overflow-hidden bg-white shadow-sm" data-id="element-12">
      {image && <div className="relative h-40 md:h-48 w-full overflow-hidden" data-id="element-13">
          <img src={image} alt={title} className="w-full h-full object-cover" data-id="element-14" />
          {/* Degradé que funde la imagen con la tarjeta */}
          <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-white via-white/60 to-transparent" data-id="element-15" />
        </div>}
      <button className="w-full px-6 py-4 flex justify-between items-center bg-white hover:bg-gray-50 transition-colors text-left" onClick={onToggle} aria-expanded={isOpen} data-id="element-16">
        <span className="font-bold text-[#1a3d1f] text-lg pr-4" data-id="element-17">{title}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.3
      }} data-id="element-18">
          <ChevronDown className="text-[#1a3d1f] w-6 h-6 flex-shrink-0" data-id="element-19" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-20">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3
      }} data-id="element-21">
            <div className="px-6 pb-4 pt-2 border-t border-gray-100" data-id="element-22">
              <ul className="space-y-2" data-id="element-23">
                {content.map((item, index) => <li key={index} className="flex items-start text-gray-700" data-id="element-24">
                    <span className="text-[#84cc16] mr-2 font-bold" data-id="element-25">✓</span>
                    <span data-id="element-26">{item}</span>
                  </li>)}
              </ul>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}